import { render, staticRenderFns } from "./ToplamStokTutari.vue?vue&type=template&id=5427e277&scoped=true"
import script from "./ToplamStokTutari.vue?vue&type=script&lang=js"
export * from "./ToplamStokTutari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427e277",
  null
  
)

export default component.exports